import Gnb from 'components/common/Gnb';
import Header from 'components/common/Header';
import ReportModal from 'src/components/report/ReportModal';
import { Outlet, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

const CommonLayout = () => {
	const [search_params] = useSearchParams();
	const report_modal_query = search_params.get('rm');

	return (
		<>
			<LayoutWrapper>
				<Header />
				<LayoutInner>
					<Gnb />
					<Outlet />
				</LayoutInner>
			</LayoutWrapper>
			{report_modal_query === 'm' && <ReportModal />}
		</>
	);
};

const LayoutWrapper = styled.div`
	width: 100%;
	height: 100%;

	${({ theme }) => theme.common.flexStart}
	flex-direction: column;
`;

const LayoutInner = styled.div`
	width: 100%;
	height: calc(100% - 88px);

	${({ theme }) => theme.common.flexStart}
`;

export default CommonLayout;
